import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class GroupSelectModel extends BaseModel {

    constructor() {
        super({ 
                name: "group",
                tableName: 'group',
                label: "group",
                display_key: 'name',
                default_order: { key: 'ordinal', direction: 'asc' } ,
            },
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                class: "common",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Bigint",
                label: 'ID', 
                primaryKey: true,
                display: false
            },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Permission name',
                    class: 'width_50',
                    width: 15,
                    filter: {type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals'},
                },
                updated_at : {
                    name: 'updated_at',
                    type: "Datetime",
                    width: 12,
                    label: 'Updated date',
                    filter: {type: 'DateRange', match: 'contains'},
                },
                group_roles: {
                    refs: `group_roles {
                          id
                          role_id
                        }`,
                    display: false
                }
        },)
    }

}
